import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.ResourceFilters;

// initial state
// object name must match specification name
const filters = {
	ResourceType: new FormControl.FilterGroup('ResourceType', 'Filter by Type', 'All Types', '', false, true, 'checkbox'),
	ResourceTopic: new FormControl.FilterGroup('ResourceTopic', 'Filter by Topic', 'All Topics', '', false, true, 'checkbox'),
	ResourceDisease: new FormControl.FilterGroup('ResourceDisease', 'Filter by Disease', 'All Diseases', '', false, true, 'checkbox'),
	searchTerm: new FormControl.FilterGroup(
		'SearchTerm', 'Search by Keyword', null, null, false, true, 'textbox',
		new FormControl.Textbox('Search')
	),
};

FormControl.assignFilters(filterObj, filters);

export { filters as default };